import { Controller, useFormContext } from 'react-hook-form';
import React from 'react';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';

export const SkillSetSelection = props => {
  const { t } = useTranslation();
  const { control, setValue, getValues } = useFormContext();
  const { skillSet } = getValues();
  const { skillSetSelectionDialog, setSkillSetSelectionDialog, onSubmitClick } = props;

  const handleCloseAction = (reason?) => {
    if (reason !== 'backdropClick') {
      setSkillSetSelectionDialog({ ...skillSetSelectionDialog, open: false });
      setValue('skillSet', null);
    }
  };

  const handleSaveAction = () => {
    setSkillSetSelectionDialog({ ...skillSetSelectionDialog, open: false });
    setValue('skillSet', null);
    onSubmitClick();
  };

  return (
    <>
      <GenericDialog
        maxWidth="sm"
        dialogTitleProps={{
          text: t('placement.OrderChangeID.selectSkillSetTitle'),
        }}
        dialogActions={[
          {
            variant: 'contained',
            color: 'tertiary',
            text: t('global.button.cancel'),
            onClick: handleCloseAction,
          },
          {
            variant: 'contained',
            text: t('global.button.save'),
            disabled: !skillSet,
            onClick: handleSaveAction,
          },
        ]}
        open={skillSetSelectionDialog.open}
        disablePortal
        draggable
        disableEscapeKeyDown
        onClose={(e, reason) => {
          handleCloseAction(reason);
        }}
      >
        <Grid spacing={3} container>
          <Grid item xs={12}>
            <Typography>{t('placement.OrderChangeID.selectSkillSetContent')}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="skillSet"
              control={control}
              render={({ field }) => (
                <FormInputDropdown
                  name="skillSet"
                  label={t('placement.OrderChangeID.skillSetControlTitle')}
                  options={skillSetSelectionDialog?.skillSetSelectionOptions ?? []}
                  inputValue={skillSet || ''}
                  handleChange={e => {
                    setSkillSetSelectionDialog({
                      ...skillSetSelectionDialog,
                      selectedSkillSet: skillSetSelectionDialog?.skillSetSelectionOptions.find(
                        x => x.Description === e.target.value,
                      ),
                    });
                    field.onChange(e.target.value);
                  }}
                  standard
                  useMenuItem
                />
              )}
            />
          </Grid>
        </Grid>
      </GenericDialog>
    </>
  );
};
